import React, { useEffect, useState } from "react";
import {
  Spin,
  message,
  Radio,
} from "antd";
import Bridge from "../../utils/Bridge";
import dayjs from "dayjs";
import moment from "moment";
import {
  ECAS_NEW_CONSENT_FORM_EFFECTIVE_DATE,
  RESEARCH_TYPE,
} from "../../utils/consts";
import ConsentFormPdfViewer from "../../components/ConsentFormPdfViewer";
import { logEvent } from "../../utils/analytics";

export default function ConsentFormChild(props) {
  const [iAcceptCheckbox, setIAcceptCheckbox] = useState(null);
  const [fullName, setFullName] = useState("");
  const [signatureDate, setSignatureDate] = useState(dayjs());
  const [loading, setLoading] = useState(false);
  const [consentFormPdfUrl, setConsentFormPdfUrl] = useState(
    ""
  );

  const get_participant_date_created = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.participants.ecas_study
      .get_participant_date_created(params)
      .then((response) => {
        if (response.status == 1 && response.data?.date_created) {
          const participantCreatedDate = moment(response.data.date_created);
          const cutoffDate = moment(ECAS_NEW_CONSENT_FORM_EFFECTIVE_DATE);
          const shouldShowNewConsentForm =
            participantCreatedDate.isValid() &&
            cutoffDate.isValid() &&
            participantCreatedDate.isSameOrAfter(cutoffDate, "day");

          if(shouldShowNewConsentForm==true){
            setConsentFormPdfUrl("./assets/documents/new-ecas-study-consent-form.pdf#toolbar=0");
          }else{
            setConsentFormPdfUrl("./assets/documents/ecas-study-consent-form.pdf#toolbar=0");
          }
        }
      })
      .catch(() => {
        // keep old consent form as fallback
      });
  };

  const get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.ecas_study
      .get(params)
      .then((response) => {
        setLoading(false);
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.field == "Consent form signed?") {
                if (item.value == "Yes") {
                  setIAcceptCheckbox(true);
                  props.set_active_step(1);
                }
              }
              if (item.field == "Consent Form Full Name") {
                setFullName(item.value || "");
              }
              if (item.field == "Consent form signed Date" && item.value) {
                const parsed = dayjs(item.value);
                if (parsed.isValid()) {
                  setSignatureDate(parsed);
                }
              }
            }
          }
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const save_details = () => {
    if (iAcceptCheckbox === null) {
      message.warning("Please select either 'I Accept' or 'I Do Not Agree'");
      return;
    }
    if (
      iAcceptCheckbox === false ||
      iAcceptCheckbox === "false" ||
      iAcceptCheckbox === "No"
    ) {
      localStorage.clear();
      window.location.assign("/");
      return;
    }
    if (!fullName.trim()) {
      message.warning("Please enter full name");
      return;
    }
    if (!signatureDate) {
      message.warning("Please select date");
      return;
    }
    const selectedDate = dayjs(signatureDate).format("MM/DD/YYYY");
    const selectedTime = dayjs(signatureDate).format("HH:mm");
    const currentDateTime = `${selectedDate} ${selectedTime}`;
    let questions = [
      {
        parent_field: "Consent form signed?",
        field: "Consent form signed?",
        value: "Yes",
      },
      {
        parent_field: "Consent Form Full Name",
        field: "Consent Form Full Name",
        value: fullName.trim(),
      },
      {
        parent_field: "Consent form signed Date",
        field: "Consent form signed Date",
        value: currentDateTime,
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "0",
      type: "consent_form",
    };

    setLoading(true);
    Bridge.demographics.ecas_study
      .save(params)
      .then((response) => {
        setLoading(false);
        if (response.data.status == "1") {
          logEvent("consent_form_submitted");
          message.success(response.data.message);
          setLoading(false);
          props.set_active_step(1);
        } else {
          message.error(response.data.message);
          setLoading(false);
        }
      })
      .catch(() => {
        // message.warning("Please try again!!", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    get_demographic_details();
    get_participant_date_created();
  }, []);

  return (
    <div>
      <div className="header">
        <h3>CONSENT FORM</h3>
        <div className="white-block"></div>
      </div>
      <Spin spinning={loading}>
        <div className="form-fields">
          <div className="form-group pdf-div">
            {consentFormPdfUrl ? (
              <ConsentFormPdfViewer
                src={consentFormPdfUrl}
                title="Consent Form"
                height={600}
              />
            ) : (
              <Spin spinning={true}></Spin>
            )}
          </div>
          <div className="form-group">
            <Radio.Group
              onChange={(event) => setIAcceptCheckbox(event.target.value)}
              value={iAcceptCheckbox}
              style={{ fontSize: 17 }}
            >
              <Radio value={true} style={{ fontSize: 17 }}>
                I Accept
              </Radio>
              <Radio value={false} style={{ fontSize: 17 }}>
                I Do Not Agree
              </Radio>
            </Radio.Group>
          </div>
          {iAcceptCheckbox === true && (
            <div className="row">
              <div className="form-group col-lg-6 pl-0">
                <label style={{ fontSize: 17, marginBottom: 10 }}>
                  Full Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
              </div>
              <div className="form-group col-lg-6 pl-0">
                <label style={{ fontSize: 17, marginBottom: 10 }}>
                  Date <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={signatureDate ? dayjs(signatureDate).format("MM/DD/YYYY HH:mm") : ""}
                  readOnly
                  disabled={true}
                  style={{ height: "58px", backgroundColor: "#f5f5f5", cursor: "not-allowed" }}
                />
              </div>
            </div>
          )}
          <button
            className="submit-button"
            style={{ padding: "9px 15px 10px 20px" }}
            onClick={() => save_details()}
          >
            Save & Next{" "}
            <box-icon
              name="chevron-right"
              color="#fff"
              style={{ position: "relative", top: 1 }}
            ></box-icon>
          </button>
        </div>
      </Spin>
    </div>
  );
}
